import {Card} from "react-bootstrap";
import React from "react";



function ServiceDeviceConnections({data}) {


    return (
        <>


            <Card bg="light" className="m-2 overflow-hidden" style={{ height: '7rem' }}>
                <Card.Title className="fw-bold px-2 pt-1 mb-0 fs-3 text-center dash-title">
                    Device Connections

                </Card.Title>

                <Card.Body className="fs-4 py-1">
                    <div className="fs-3 fw-bold d-inline">{data.totalDevices - data.downDevices}</div>
                    <div className="d-inline"> of </div>
                    <div className="fs-3 fw-bold d-inline">{data.totalDevices}</div>
                    <div className="d-inline"> total field devices communicating.</div>
                </Card.Body>

            </Card>

        </>
    );
}

export default ServiceDeviceConnections;
